import * as XLSX from "xlsx-js-style";

export const exportToExcelFpsStock = ({ month, year, fps_id, reportData, fpsStatus, tabHeading, MonthC }) => {
    if (!reportData || reportData.length === 0) return;

    const showType = reportData.some(item => item.type !== null && item.type !== undefined);
    const colCount = showType ? 14 : 13;
    const typeOffset = showType ? 1 : 0;

    const wsData = [];

    const titleRow = [
        {
            v: `${tabHeading} for FPS Id : ${fps_id} ${fpsStatus ? `( FPS Status : ${fpsStatus} )` : ""} ( District : ${reportData[0].distNameEn} ) ${MonthC[parseInt(month) - 1]} - ${year}`,
            s: { font: { bold: true, sz: 12 }, alignment: { horizontal: "center" } }
        }
    ];
    wsData.push(titleRow);

    const headerRow1 = [
        "Sl.No", "Commodity",
        ...(showType ? ["Type"] : []),
        "Units", "Alloted Qty", " OB Qty\n(A)", " Received Qty", "", "", "", "", "", "Issued Qty\n(E)", " CB Qty\n(A+B+C+D-E)"
    ];
    const headerRow2 = [
        "", "",
        ...(showType ? [""] : []),
        "", "", "", " Regular", "", "", "", "Extra\n(C)", " Moved\n(D)", "", ""
    ];
    const headerRow3 = [
        "", "",
        ...(showType ? [""] : []),
        "", "", "", "Previous Month", "Current Month", "Future Month", " Total\n(B)", "", "", "", ""
    ];

    const headerStyle = { font: { bold: true }, alignment: { horizontal: "center", vertical: "center", wrapText: true } };

    wsData.push(headerRow1.map(val => ({ v: val, s: headerStyle })));
    wsData.push(headerRow2.map(val => ({ v: val, s: headerStyle })));
    wsData.push(headerRow3.map(val => ({ v: val, s: headerStyle })));

    reportData.forEach((item, index) => {
        wsData.push([
            index + 1,
            item.commNameEn,
            ...(showType ? [item.type] : []),
            item.commMeasureUnit,
            item.allottedQty,
            item.ob,
            item.prevMonth,
            item.curntMonth,
            item.futrMonth,
            item.receivedQty,
            item.extraRo,
            item.sixaCase,
            item.issuedQty,
            item.cb
        ]);
    });

    const refreshRow = Array(colCount).fill("");
    refreshRow[colCount - 2] = { v: "Data Time:", s: { alignment: { horizontal: "right" } } };
    refreshRow[colCount - 1] = { v: reportData[0]?.refreshTime?.substring(0, 16), s: { font: { color: { rgb: "FF0000" } }, alignment: { horizontal: "left" } } };
    wsData.push(refreshRow);

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: colCount - 1 } }, // Title
        { s: { r: 1, c: 0 }, e: { r: 3, c: 0 } }, // Sl.No
        { s: { r: 1, c: 1 }, e: { r: 3, c: 1 } }, // Commodity
        ...(showType ? [{ s: { r: 1, c: 2 }, e: { r: 3, c: 2 } }] : []), // Type
        { s: { r: 1, c: 2 + typeOffset }, e: { r: 3, c: 2 + typeOffset } }, // Units
        { s: { r: 1, c: 3 + typeOffset }, e: { r: 3, c: 3 + typeOffset } }, // Alloted Qty
        { s: { r: 1, c: 4 + typeOffset }, e: { r: 3, c: 4 + typeOffset } }, // OB Qty
        { s: { r: 1, c: 5 + typeOffset }, e: { r: 1, c: 10 + typeOffset } }, // Received Qty
        { s: { r: 2, c: 5 + typeOffset }, e: { r: 2, c: 8 + typeOffset } }, // Regular
        { s: { r: 2, c: 9 + typeOffset }, e: { r: 3, c: 9 + typeOffset } }, // Extra
        { s: { r: 2, c: 10 + typeOffset }, e: { r: 3, c: 10 + typeOffset } }, // Moved
        { s: { r: 1, c: 11 + typeOffset }, e: { r: 3, c: 11 + typeOffset } }, // Issued Qty
        { s: { r: 1, c: 12 + typeOffset }, e: { r: 3, c: 12 + typeOffset } }, // CB Qty
    ];

    ws["!cols"] = [
        { wch: 8 }, { wch: 20 },
        ...(showType ? [{ wch: 15 }] : []),
        { wch: 10 }, { wch: 12 }, { wch: 12 },
        { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 12 },
        { wch: 12 }, { wch: 12 }, { wch: 15 }
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "FPS Stock Details");
    XLSX.writeFile(wb, `FPS_Stock_Details_${fps_id}_${month}_${year}.xlsx`);
};
